import { createContext, useContext, useEffect, useState } from "react";
import { safeLocalStorage } from "@/lib/safeStorage";

const ThemeContext = createContext(null);
export const THEME_STORAGE_KEY = "simpler_theme_v2";
const LEGACY_STORAGE_KEY = "simpler_theme";

export function ThemeProvider({ children, defaultTheme = "light" }) {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return defaultTheme;
    const salvo = safeLocalStorage.getItem(THEME_STORAGE_KEY);
    return salvo === "dark" || salvo === "light" ? salvo : defaultTheme;
  });

  useEffect(() => {
    safeLocalStorage.removeItem(LEGACY_STORAGE_KEY);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
  }, [theme]);

  // Só grava quando a pessoa escolhe o tema.
  const setTheme = (next) => {
    safeLocalStorage.setItem(THEME_STORAGE_KEY, next);
    setThemeState(next);
  };

  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
